import React, { Component } from 'react';
import PropTypes from 'prop-types';
import create360Viewer from '360-image-viewer';
import canvasFit from 'canvas-fit';
import icons from './../utils/import.icons'
 
class Viewer360 extends Component{
    
    constructor(props){
        super(props);
        
        this.state = {
            image: null,
            viewer: null,
            fadeIn: false
        }

        this.canvasRef = React.createRef();
    }

    componentDidMount(){
        this.setState(prevState => ({
            image: this.props.path
            
        }))
    }

    componentDidUpdate( prevProps, prevState){
        
        let { path } = this.props;

        if(prevState.image === path){
            return;
        }

        const image = new Image();
        image.src = path;
        
        image.onload = () => {
            // when the image is loaded, setup the viewer
            const viewer = create360Viewer({
                image: image,
                canvas: this.canvasRef.current,
                theta: -(0.7) * Math.PI / 2,
                phi: (0.7) * Math.PI * .485,
                rotateSpeed: -0.15,
                fov: 62 * Math.PI / 180
            });
            
            // attach canvas to body
            //document.body.appendChild(viewer.canvas);
            
            // setup fullscreen canvas sizing
            const fit = canvasFit(viewer.canvas, window, window.devicePixelRatio);
            window.addEventListener('resize', fit, false);
            fit();
            
            // start the render loop
            viewer.start();
        
            this.setState({
                fadeIn: true
            })

            setTimeout(() => {
                this.props.onReady();    
            }, 1000);
            

            
        };

    }

    handleGetCarName = () => {
        console.log(this.props.name.Nombre)
        return <img src={icons[this.props.name.Nombre]}></img>
    }

    render() {
        return (
            <div>
                <canvas 
                className={this.state.fadeIn ? "canvas360 fadeIn" : 'canvas360'}
                ref={this.canvasRef}
                />
                <button className = "close-360" onClick = {() => this.props.handleOutBtn()}><img src={icons["out"]} alt=''></img></button>
                <div className="nombre-container">
                    {
                        this.handleGetCarName()
                    }
                </div>
            </div>
        );
      
    }
}

Viewer360.propTypes = {
    path: PropTypes.string,
    onReady: PropTypes.func
}

Viewer360.defaultProps = {
    path: undefined,
    onReady: () => {}
}

export default Viewer360;